import { defineStore } from 'pinia'
import type { StoreContent } from '~/types/global'
export const useStore = defineStore({
  id: 'store',
  state: (): StoreContent => {
    const runtimeConfig = useRuntimeConfig()
    const isDev = runtimeConfig.public.isDev
    const app = useNuxtApp()

    const headers = {
      'Accept-Language': app.$i18n.locale.value,
      'X-PRODUCT': 'STORE_WEB',
      ...(isDev
        ? {
            'CF-Access-Client-Id': runtimeConfig.public.CFAccessClientId,
            'CF-Access-Client-Secret': runtimeConfig.public.CFAccessClientSecret
          }
        : {})
    }

    return {
      error: null,
      firebaseUser: null,
      categories: null,
      miioUser: null,
      validateEmail: false,
      defaultVehicle: null,
      shippingAddressList: null,
      vats: null,
      paymentMethods: null,
      basketPaymentMethodId: null,
      requireLoginValidation: {
        phoneNumber: false,
        country: false
      },
      recentProducts: [],
      recentSearch: [],
      compareProducts: [],
      basket: null,
      isUpdatingBasket: false,
      order: null,
      chargingPreferences: null,
      customSEO: null,
      promos: null,
      docs: {
        conditions: 'https://miio-app-photos.s3.eu-west-3.amazonaws.com//docs/Condi%C3%A7%C3%B5es+Gerais+de+Fornecimento+de+Eletricidade+para+a+Mobilidade+El%C3%A9trica+.pdf',
        network:
          'https://www.mobie.pt/documents/42032/192209/Condi%C3%A7%C3%B5es+de+Utiliza%C3%A7%C3%A3o+da+Rede+de+Mobilidade+El%C3%A9trica_Fase+de+Mercado.pdf/21d83f9a-7936-fcf3-5dde-88dcf593f058?t=1634730974710'
      },
      tokens: null,
      rewards: null,
      wallets: null,
      loading: true,
      headers
    }
  }
})
